import React, { useEffect, useState } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { TextField } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import FlagstoneTheme from '../../../Config/flagstoneTheme';
import { useTranslation } from 'react-i18next';
import {getReadableBarcode} from '../../../Helpers/generalHelper';

export default function NewBookingDialog(props) {

    const classes = useStyles();
    const [paletNumber, setPaletNumber] = useState(null)
    const [stackingHeight, setStackingHeight] = useState(null)
    const {t} = useTranslation();

    useEffect(() => {
        setPaletNumber(null)
        setStackingHeight(null)
    }, [props.dialogOpen])

    return (
        <Dialog className={classes.dialogContainer}
            open={props.dialogOpen}
            aria-labelledby="draggable-dialog-title"
            onClose = {props.closeDialog}
        >
            <div className={classes.dialogTitle} style={{ cursor: 'move' }} id="draggable-dialog-title">
                {props.dialogTitle}
            </div>
            <div className={classes.dialogContext}>
                {props.dialogContext}
            </div>
            <div className={classes.label}>{t("Palet Number")}</div>
            <TextField id="outlined-search" size="small" label="" type="number" variant="outlined" value={paletNumber} className={classes.uiTextField} onChange={(e) => setPaletNumber(getReadableBarcode(e.target.value))} />
            <div className={classes.label} style={{marginTop:"10px"}}>{t("Stacking Height (mm)")}</div>
            <TextField id="outlined-search" size="small" label="" type="number" variant="outlined" value={stackingHeight} className={classes.uiTextField} onChange={(e) => setStackingHeight(e.target.value)} />
            <DialogActions>
                <div className={classes.buttons}>
                    <Button className={classes.cancelButton} onClick={() => props.closeDialog()}>
                        {t("CANCEL")}
              </Button>
                    <Button className={classes.bookButton} disabled={!paletNumber || !stackingHeight} onClick={() => props.action(stackingHeight, paletNumber)}>
                    {t("BOOK")}
              </Button>
                </div>
            </DialogActions>
        </Dialog>
    );
}


const useStyles = makeStyles(() => ({

    dialogContainer: {
        width: "620px !important",
        height: "auto !important",
        margin: "auto",
        "& > div > div": {
            backgroundImage: 'linear-gradient(#EFEFEF,#FFFFFF)'
        },
    },
    buttons: {
        textAlign: "center",
        marginLeft: "auto",
        marginRight: "auto",
        width: "235px",
        marginBottom: "20px"
    },
    bookButton: {
        color: "white",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        backgroundColor: FlagstoneTheme.palette.primary.main,
        '&:hover': {
            backgroundColor: FlagstoneTheme.palette.primary.main,
        },
        margin: "3px",
        width: "110px",
        marginBottom: "30px",
        marginTop: "20px",
        float: "left"
    },
    cancelButton: {
        color: FlagstoneTheme.palette.primary.main,
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        backgroundColor: "#E6E8FE",
        '&:hover': {
            backgroundColor: "#E6E8FE",
        },
        margin: "3px",
        width: "110px",
        marginBottom: "30px",
        marginTop: "20px",
        float: "left"
    },
    dialogTitle: {
        color: "#000000",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center",
        fontSize: "32px !important",
        paddingTop: "0px",
        paddingBottom: "0px",
        marginTop: "50px",
        marginBottom: "5px",
        width: "520px"
    },
    dialogContext: {
        color: "#000000",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center",
        paddingLeft: "50px",
        paddingRight: "50px",
        height: "20px",
        marginBottom: "15px"
    },
    uiTextField: {
        width: "300px",
        backgroundColor: "white",
        marginRight: "auto",
        marginLeft: "auto"
    },
    textField: {
        width: "300px",
        marginRight: "auto",
        marginLeft: "auto"
    },
    label: {
        color: "#000000",
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        width: "300px",
        marginRight: "auto",
        marginLeft: "auto",
        marginTop: "5px"
    }
}));
